import styled from 'styled-components'

export const Root = styled.section`
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 15px 0 18px;
  @media (max-width: 680px) { flex-direction: column; gap: 8px; }
`;
export const Label = styled.span`
  flex: 0 0 auto;
  padding-top: 8px;
  color: ${({ theme }) => theme.palette.colors.subdued};
  font-family: Poppins, sans-serif;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.11em;
  text-transform: uppercase;
`;
export const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
`;
export const Chip = styled.button`
  min-height: 34px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 6px 11px 6px 13px;
  border: 1px solid ${({ active, theme }) => active ? theme.palette.blue.main : theme.palette.colors.cardBorder};
  border-radius: 999px;
  background: ${({ active, theme }) => active ? theme.palette.colors.badgeMuted : theme.palette.colors.chipSurface};
  color: ${({ theme }) => theme.palette.colors.text};
  cursor: pointer;
  &:hover { border-color: ${({ theme }) => theme.palette.blue.main}; }
  &:focus-visible { outline: 2px solid ${({ theme }) => theme.palette.blue.main}; outline-offset: 2px; }
`;
export const ChipName = styled.span`
  font-family: Lato, sans-serif;
  font-size: 13px;
  font-weight: 700;
`;
export const ChipCount = styled.span`
  color: ${({ theme }) => theme.palette.colors.subdued};
  font-family: Lato, sans-serif;
  font-size: 12px;
  font-weight: 700;
`;
